// extracted by css-extract-rspack-plugin
export default {"orgTitle":"Z0XIWC2LpwMFHXka","buttons":"xmyWPvdz_Cwk2Gcs"};